import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function ImageUpload({ logo, onUpload }) {
  const [image, setImage] = useState(logo || null);

  useEffect(() => {
    setImage(logo || null);
  }, [logo]);

  const handleChange = e => {
    const file = e.target.files[0];
    if (file) {
      const reader = new window.FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        setImage(result);
        if (onUpload) {
          onUpload(result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex flex-col items-start space-y-4">
      {image && <img src={image} alt="Preview" className="w-40 h-40 object-cover rounded" />}
      <label
        htmlFor="image-upload"
        className="cursor-pointer text-sm text-white bg-gray-400 px-4 py-2 rounded hover:bg-gray-500 transition"
      >
        Upload Image
      </label>
      <input
        id="image-upload"
        type="file"
        accept="image/*"
        onChange={handleChange}
        className="hidden"
      />
    </div>
  );
}

ImageUpload.propTypes = {
  logo: PropTypes.string,
  onUpload: PropTypes.func
};
